import { Injectable, inject } from '@angular/core'
import { select, Store, Action } from '@ngrx/store'
import * as SiteAnnouncementsSelectors from './site-announcements.selectors'
import { GbBaseFacade } from 'libs/shared/data-access-core/src/lib/+state/gb-base-facade-interface'

@Injectable({
  providedIn: 'root',
})
export class SiteAnnouncementsFacade implements GbBaseFacade {
  private readonly store = inject(Store)

  loaded$ = this.store.pipe(select(SiteAnnouncementsSelectors.selectSiteAnnouncementsLoaded))
  allSiteAnnouncements$ = this.store.pipe(select(SiteAnnouncementsSelectors.selectAllSiteAnnouncements))
  displayedSiteAnnouncements$ = this.store.pipe(select(SiteAnnouncementsSelectors.selectDisplayedSiteAnnouncements))
  selectedSiteAnnouncements$ = this.store.pipe(select(SiteAnnouncementsSelectors.selectEntity))

  editCreateLoaded$ = this.store.pipe(select(SiteAnnouncementsSelectors.selectEditCreateLoaded))

  dispatch(action: Action) {
    this.store.dispatch(action)
  }
}
